<div fxLayout="column" fxLayoutAlign="center center">
  <div class="content">
    <p>
      In order to protect your identity, we'll need to confirm who you are. To access the form, either enter the six
      digit code we sent to <span class="style-bold">{{ email }}</span
      >, or click on the link in that email.
    </p>
    <div fxLayout="column" class="code-input-container" *ngIf="!expired">
      <ng-otp-input [config]="config" (onInputChange)="handleCodeChange($event)" #ngOtpInput> </ng-otp-input>
    </div>
    <div *ngIf="!expired">
      <p>Didn't receive an email?</p>
      <button mat-raised-button color="primary" (click)="requestCode()">REQUEST NEW CODE</button>
    </div>
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>
</div>
